module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-8.6f2c7e85.jpg";